import PageHeader from '@/components/PageHeader';
import { BoxProps } from '@/components/ui/Box';
import LayoutDefault from '@/layouts/Layout';
import { PageEntryTypes } from '@/lib/parsers/entries';
import { Fragment, type ReactNode } from 'react';

export type IndexLayoutProps = BoxProps<
  'div',
  {
    entry: PageEntryTypes;
    index: ReactNode;
    nav: ReactNode;
    footer: ReactNode;
  }
>;

const IndexLayout = ({
  entry,
  nav,
  footer,
  colorTheme = 'default',
  index,
  ...props
}: IndexLayoutProps) => {
  return (
    <LayoutDefault
      {...{ entry, colorTheme, ...props }}
      slots={{
        nav,
        header: <PageHeader entry={entry} />,
        body: [<Fragment key="entryIndex">{index}</Fragment>],
        footer,
      }}
    />
  );
};

export default IndexLayout;
